<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="foodKinds"
    :title="`${$t('title.selectfoodkind')}`"
    idProperty="FoodKindId"
    nameProperty="FoodKindName"
    allSelectId="foodKindAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="FoodKindNumber"
    :defaultItems="defaultItems"
    viewName="FoodKindSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      foodKinds: [],
      columns: [
        {
          name: "FoodKindNumber",
        },
        {
          name: "FoodKindName",
        },
      ],
      id: "foodKindSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
    defaultItems(val) {
      if (val) {
        this.foodKinds = val;
      }
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      const vm = this;
      this.$api.foodKinds.getPages(dTO).then((data) => {
        vm.foodKinds = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
